import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
  inject,
  Input,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { SessionStorageService } from '../services/session-storage.service';
import { RixtremaService } from '../rixtrema/rixtrema.service';
import { UnifiedFlowService } from '../unified-flow/unified.service';
import { DocumentReaderService } from '../services/document-reader.service';
import { MatSelectModule } from '@angular/material/select';
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MaskService } from '../services/mask.service';
import { MaskitoDirective } from '@maskito/angular';

import { InvestmentWizardService } from '../investment-wizard/services/investment-wizard-service.service';
import {
  KENDO_PDFVIEWER,
  PDFViewerTool,
} from '@progress/kendo-angular-pdfviewer';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { MonthYearDateDisplayDirective } from '../directives/month-year-date-display.directive';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { ParsedItem } from '../models/doc-reader-models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SortKeyValuePipe } from '../sort-key-value.pipe';
import { NgxLoadingModule } from 'ngx-loading';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/dd/yyyy',
  },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
@Component({
  selector: 'app-document-reader',
  imports: [
    MatRadioModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    CommonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatRadioModule,
    ReactiveFormsModule,
    MaskitoDirective,
    KENDO_PDFVIEWER,
    MonthYearDateDisplayDirective,
    SortKeyValuePipe,
    NgxLoadingModule,
    LoadingDialogComponent,
    MatCardModule,
    MatTabsModule,
    MatTooltipModule,
  ],
  templateUrl: './document-reader.component.html',
  styleUrl: './document-reader.component.scss',
  providers: [provideLuxonDateAdapter(MY_FORMATS)],
})
export class DocumentReaderComponent implements OnInit, OnDestroy {
  private dialog = inject(MatDialog);
  private dialogRef =
    inject<MatDialogRef<DocumentReaderComponent>>(MatDialogRef);
  private admnSrvc = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  private rixtremaSrc = inject(RixtremaService);
  private unifiedFlowService = inject(UnifiedFlowService);
  private docReadSvc = inject(DocumentReaderService);
  mask = inject(MaskService);
  private iws = inject(InvestmentWizardService);
  private breakpointObserver = inject(BreakpointObserver);
  private changeDetector = inject(ChangeDetectorRef);
  data = inject<{
    index: any;
    group: any;
    profile: any;
    varset: any;
    modalDisplay: any;
    uploadSettings: any;
    getQuestions: any;
    saveToModel: any;
    additionalData: any;
    docReadFundDetailIDs: any;
    buttonType: any;
  }>(MAT_DIALOG_DATA);
  private snacky = inject(MatSnackBar);

  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;
  @Input() templateMode = false;
  @Output() submittedSelection = new EventEmitter();
  @Output() templateDataOut = new EventEmitter();
  selectedItem = null;
  selectedItems = {};
  loading: boolean;
  multipleItemsFound = false;
  parsedFields = [];
  itemType: string;
  fileTypes: string;
  disclosure: string;
  instructions: string;
  selectTitle: string;
  title: string;
  validationTitle: string;
  parseErrorText: string;
  exchangeData: any;
  groupIndex: any;
  server: any;
  fundType: any;
  subplanID: any;
  selectedPlanData: any;
  arrayObj = Array;
  fundDetailsVarset: any;
  fieldLabels;
  dollarMask: any;
  percentMask: any;
  loadingHeadline = 'Reading File...';
  loadingContent = null;
  loadingChangeContent = [
    'Loading Document',
    'Pulling Information from Document',
    'Processing Data',
    'Preparing to Load to Form',
    'Loading to Form - Please wait as this may take some time',
  ];
  showNetworkLoading: boolean;
  fundDetailsOrder = ['FundID', 'Name', 'ExpenseRatio', 'Amount'];
  fourOhFourAFiveVarsets = [
    'CPRolloverFundDetails',
    'CPRollover403bFundDetails',
  ];
  pdfViewerTools: PDFViewerTool[] = [
    'pager',
    'spacer',
    'zoom',
    'zoomInOut',
    'selection',
  ];
  currentStepStack: { stepType: string; alerts?: string[]; file?: string }[] =
    [];
  pdfBase64: any;
  timeoutList = [];
  loadingVal: number;
  maxTime = 70000;
  isDialog: any;
  currContentIdx = 0;
  content: string;
  changeContent: any;
  mainLoading: any;
  isSmallScreen$: Observable<boolean>;
  maxFiles: any;
  currentFiles: any[] = [];
  tooManyFiles: boolean;
  unacceptableFilesError: boolean;
  unacceptableFileNames: string[];
  dupFilesError: boolean;
  dupFileNames: string[];
  filesLoading: { file: string; subscription: Subscription }[] = [];
  currentStep: any;
  userSelectedItem: any;
  itemsToSelect = {};
  duplicates: {
    field: string;
    dupValues: { value: string; keys: any; checked: boolean }[];
  }[];
  displayPdfData: { file: string; data: string }[];
  errorFiles: string[];
  questionnaireData: unknown;
  loadingFields: boolean;
  piiSave: boolean;
  piiErrorSave: boolean;
  bypassAIProcess: boolean;
  normalFileErrorSave: boolean;
  normalFileSave: boolean;
  errorSaveFiles: File[];
  uploadedSaveFiles: File[];
  parseAlerts: string[] = [];
  errorSaveMessage: string = '';
  fileTypeMap: Map<string, string> = new Map();

  constructor() {
    this.disclosure =
      this.data.modalDisplay?.docModalDisclosure ||
      'Note: This data was parsed via AI and could possibly contain errors. Please compare the data to the original document to ensure accuracy.';
    this.fileTypes =
      this.data.modalDisplay?.docModalFileTypes ||
      '.xsl,.xslx,.doc,.docx,.pdf,.png,.jpg,.jpeg,.csv,.json,.xml,.txt';
    this.instructions =
      this.data.modalDisplay?.docModalInstructions ||
      'Please select a file to send to our AI document reader.';
    this.selectTitle =
      this.data.modalDisplay?.docModalSelectTitle ||
      'Multiple sets of data found. Please select one to use for this case.';
    this.title = this.data.modalDisplay?.docModalTitle || 'Document Reader';
    this.validationTitle =
      this.data.modalDisplay?.docModalValidationTitle ||
      'Please select/edit all fields below that you want to include in this case.';
    this.parseErrorText =
      this.data.modalDisplay?.docModalError ||
      'There was an error processing this file. If this error persists, please contact your administrator.';
    this.maxFiles = this.data.modalDisplay?.maxFiles || 1;
    this.dollarMask = this.mask.dollarMaskSpecs();
    this.percentMask = this.mask.percentMaskSpecs();

    this.isSmallScreen$ = this.breakpointObserver
      .observe([
        Breakpoints.Large,
        Breakpoints.Medium,
        Breakpoints.Small,
        Breakpoints.XSmall,
      ])
      .pipe(
        map(result => result.matches),
        shareReplay()
      );
  }

  ngOnInit(): void {
    this.groupIndex = this.data.additionalData?.groupIndex;
    this.server = this.data.additionalData?.server;
    this.fundType = this.data.additionalData?.fundType;
    this.fundDetailsVarset = this.data.additionalData?.fundDetailsVarset;
    this.bypassAIProcess = this.data.additionalData?.bypassAIProcess;
    this.currentStepStack.push({ stepType: 'upload' });
    this.currentStep = { stepType: 'upload' };
  }

  ngOnDestroy(): void {
    this.fieldLabels = null;
    this.selectedItem = null;
    this.userSelectedItem = null;
    this.selectedItems = null;
  }

  loadingTimer() {
    this.content = this.loadingChangeContent[0] || 'Loading Document';
    this.timeoutList = [];
    this.loadingVal = 1;
    this.currContentIdx = 0;
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 10;
      }, this.maxTime * 0.1)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 17;
        if (!this.isDialog) {
          this.currContentIdx += 1;
          this.content = this.loadingChangeContent[this.currContentIdx];
        }
      }, this.maxTime * 0.17)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 25;
      }, this.maxTime * 0.25)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 37;
      }, this.maxTime * 0.37)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 45;
        if (!this.isDialog) {
          this.currContentIdx += 1;
          this.content = this.loadingChangeContent[this.currContentIdx];
        }
      }, this.maxTime * 0.45)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 60;
      }, this.maxTime * 0.6)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 63;
      }, this.maxTime * 0.63)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 65;
      }, this.maxTime * 0.65)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 68;
        if (!this.isDialog) {
          this.currContentIdx += 1;
          this.content = this.loadingChangeContent[this.currContentIdx];
        }
      }, this.maxTime * 0.68)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 70;
      }, this.maxTime * 0.7)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 78;
      }, this.maxTime * 0.78)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 83;
      }, this.maxTime * 0.83)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 86;
      }, this.maxTime * 0.86)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 90;
      }, this.maxTime * 0.9)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 93;
      }, this.maxTime * 0.93)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 95;
      }, this.maxTime * 0.95)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 95;
      }, this.maxTime * 0.95)
    );
    this.timeoutList.push(
      setTimeout(() => {
        this.loadingVal = 98;
        if (!this.isDialog) {
          this.currContentIdx += 1;
          this.content = this.loadingChangeContent[this.currContentIdx];
        }
      }, this.maxTime * 0.98)
    );
  }

  cancelDialog() {
    this.dialogRef.close('cancel');
  }

  getCurrentStepIndex() {
    return this.currentStepStack.findIndex(
      stackItem =>
        (stackItem.file === this.currentStep.file &&
          stackItem.stepType === this.currentStep.stepType) ||
        (stackItem.file === undefined &&
          stackItem.stepType === this.currentStep.stepType)
    );
  }

  next(): void {
    const currentStepIndex = this.getCurrentStepIndex();
    switch (this.currentStep.stepType) {
      case 'upload':
        this.onFileSubmit();
        break;
      case 'select':
        this.multipleItemsFound = false;
        this.selectedItems[this.currentStep.file] = this.userSelectedItem;
        this.currentStep = this.currentStepStack[currentStepIndex + 1];
        this.fillParsedFields();
        break;
      case 'parse': {
        const allFilesParsed = this.currentFiles.every(
          (file: File) =>
            this.currentStepStack.some(
              step => step.stepType === 'parse' && step.file === file.name
            ) || this.errorFiles.includes(file.name)
        );

        const currentParseStepIndex = this.currentStepStack.findIndex(
          step =>
            (step.file === this.currentStep.file &&
              step.stepType === this.currentStep.stepType) ||
            (step.file === undefined &&
              step.stepType === this.currentStep.stepType)
        );

        if (currentParseStepIndex === this.currentStepStack.length - 1) {
          if (!allFilesParsed) {
            // Move to loading screen if at the end of the step stack and not all files are parsed
            this.loadingHeadline = 'Reading File...';
            this.currentStepStack.push({ stepType: 'loading' });
            this.currentStep = { stepType: 'loading' };
          } else {
            if (this.errorFiles.length > 0) {
              this.currentStepStack.push({ stepType: 'error' });
              this.currentStep = { stepType: 'error' };
            } else {
              // If all files are parsed, submit the selection
              this.findDuplicateQuestions();
            }
          }
        } else {
          // Move to the next step
          this.currentStep = JSON.parse(
            JSON.stringify(this.currentStepStack[currentParseStepIndex + 1])
          );
          // if (this.currentStep.stepType === 'parse') {
          //   this.fillParsedFields();
          // }
        }
        break;
      }
      case 'reconcile':
        this.updateSelectedItemsFromDuplicates();
        this.submitSelection();
        break;
      case 'error':
        this.findDuplicateQuestions();
        break;
      default:
        break;
    }
  }

  back(): void {
    // this.currentStepStack.pop();
    const currentStepIndex = this.getCurrentStepIndex();
    this.currentStep = this.currentStepStack[currentStepIndex - 1];
    if (this.currentStep.stepType === 'upload') {
      this.startOver();
    }
  }

  startOver(): void {
    this.currentStepStack = [{ stepType: 'upload' }];
    this.currentStep = { stepType: 'upload' };
    this.loading = false;
    this.mainLoading = false;
    this.currentFiles = [];
    this.errorFiles = [];
    this.filesLoading = [];
    this.uploadedSaveFiles = [];
    this.errorSaveFiles = [];
    this.normalFileSave = false;
    this.normalFileErrorSave = false;
    this.fileTypeMap.clear();
    this.timeoutList.forEach(timerItem => {
      clearTimeout(timerItem);
    });
  }

  includeItem(itemKey: string, dataArray): boolean {
    //include if:
    // key exists AND response has data for it AND field is not excluded
    return !!this.fieldLabels.find(fieldLabel => {
      return (
        (fieldLabel.key === `${itemKey}` ||
          fieldLabel.key === `${itemKey}`.replace('.', '_') ||
          fieldLabel.key === `${this.data.varset}_${itemKey}` ||
          fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}`) &&
        !!dataArray.find(item => {
          return (
            (item[itemKey] || item['field']) &&
            (!fieldLabel.excludeFromDocReading ||
              (fieldLabel.excludeFromDocReading &&
                fieldLabel.key.split('_')[1] === 'EnterAccountHoldings'))
          );
        })
      );
    });
  }

  displayItemField(itemKey: string): boolean {
    // display if:
    // key exists AND not excluded
    return !!this.fieldLabels.find(fieldLabel => {
      return (
        (fieldLabel.key === `${itemKey}` ||
          fieldLabel.key === `${itemKey}`.replace('.', '_') ||
          fieldLabel.key === `${this.data.varset}_${itemKey}` ||
          fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}` ||
          (itemKey === 'fundDetails' &&
            fieldLabel.key.toLowerCase().includes('funddetails')) ||
          (itemKey === undefined && this.itemType === 'accounts')) &&
        !fieldLabel.excludeFromDocReading
      );
    });
  }

  getItemLabel(itemKey, group = false): string {
    if (group) {
      return (
        this.fieldLabels.find(labelItem => labelItem.varset === itemKey)
          ?.label || itemKey
      );
    }
    // fallback logic:
    // label -> placeholder -> prompt -> key
    const foundLabel = this.fieldLabels.find(
      fieldLabel =>
        fieldLabel.key === `${itemKey}` ||
        fieldLabel.key === `${itemKey}`.replace('.', '_') ||
        fieldLabel.key === `${this.data.varset}_${itemKey}` ||
        fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}`
    );

    return (
      foundLabel?.label ||
      foundLabel?.props?.placeholder ||
      foundLabel?.props?.prompt ||
      foundLabel?.key
    );
  }

  getItemType(itemKey): string {
    return this.fieldLabels.find(
      fieldLabel =>
        fieldLabel.key === `${itemKey}` ||
        fieldLabel.key === `${itemKey}`.replace('.', '_') ||
        fieldLabel.key === `${this.data.varset}_${itemKey}` ||
        fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}`
    )?.type;
  }

  getItemData(itemKey, item?): { label: string; value: string }[] {
    return (
      this.fieldLabels.find(
        fieldLabel =>
          fieldLabel.key === `${itemKey}` ||
          fieldLabel.key === `${itemKey}`.replace('.', '_') ||
          fieldLabel.key === `${this.data.varset}_${itemKey}` ||
          fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}`
      )?.props?.options || item?.options
    );
  }

  getItemGroup(itemKey): { label: string; value: string }[] {
    const groupItem = this.fieldLabels.find(
      fieldLabel =>
        fieldLabel.key === `${itemKey}` ||
        fieldLabel.key === `${itemKey}`.replace('.', '_') ||
        fieldLabel.key === `${this.data.varset}_${itemKey}` ||
        fieldLabel.key === `${this.fundDetailsVarset}_${itemKey}`
    )?.props?.group;
    if (isNaN(+groupItem)) {
      return groupItem;
    }
    return null;
  }

  onFileSelected(event, fileClass = 'multi') {
    switch (fileClass) {
      case 'multi': {
        // Check for dups and unacceptable file types
        const unacceptableFiles: string[] = [];
        const dupFiles: string[] = [];
        const acceptableFiles: File[] = Array.from(event.target.files).filter(
          (file: File) => {
            const fileExtension = file.name.split('.').pop()?.toLowerCase();

            // Check for dups
            const isDuplicate = this.currentFiles.some(
              currentFile => currentFile.name === file.name
            );
            if (isDuplicate) {
              dupFiles.push(file.name);
              return false; // Exclude duplicate files
            }

            // Check for unacceptable file types
            if (!this.fileTypes.includes(`.${fileExtension}`)) {
              unacceptableFiles.push(file.name);
              return false; // Exclude unacceptable files
            }

            return true; // Include files that pass both checks
          }
        ) as File[];

        // Set flags for dups and unacceptable files
        this.dupFilesError = dupFiles.length > 0;
        this.unacceptableFilesError = unacceptableFiles.length > 0;

        if (this.unacceptableFilesError) {
          this.unacceptableFileNames = unacceptableFiles;
        }

        if (this.dupFilesError) {
          this.dupFileNames = dupFiles;
        }

        // Check if adding the files exceeds the maxFiles limit
        if (this.currentFiles.length + acceptableFiles.length > this.maxFiles) {
          this.tooManyFiles = true;
        } else {
          if (this.tooManyFiles) this.tooManyFiles = false;
          this.currentFiles = [...this.currentFiles, ...acceptableFiles];
        }
        break;
      }

      default:
        break;
    }
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.target as HTMLElement;
    dropZone.classList.add('drag-over');
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.target as HTMLElement;
    dropZone.classList.remove('drag-over');
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.target as HTMLElement;
    dropZone.classList.remove('drag-over');

    if (event.dataTransfer?.files) {
      const files = event.dataTransfer.files;
      this.onFileSelected({ target: { files } } as any);
    }
  }

  removeFile(ev, index): void {
    this.dupFilesError = false;
    this.unacceptableFilesError = false;
    this.tooManyFiles = false;
    this.currentFiles.splice(index, 1);
  }

  onFileSubmit() {
    if (this.bypassAIProcess) {
      this.saveSelectedFiles(true);
    } else {
      const context: {
        clientFirstName: string;
        clientLastName: string;
        varset: string;
        dateToday: string;
        dateRequirement?: string;
      } = {
        clientFirstName: this.data.additionalData.clientFirstName,
        clientLastName: this.data.additionalData.clientLastName,
        varset: this.data.varset,
        dateToday: this.data.additionalData.dateToday,
      };
      if (this.data.additionalData.dateRequirement) {
        context['dateRequirement'] = this.data.additionalData.dateRequirement;
      }
      this.displayPdfData = [];
      this.errorFiles = [];
      this.loadingTimer();
      this.currentStepStack.push({ stepType: 'loading' });
      this.currentStep = { stepType: 'loading' };

      this.filesLoading = [];
      this.fileTypeMap.clear();

      this.currentFiles.forEach((file: File, index) => {
        this.fieldLabels =
          !this.fieldLabels || this.fieldLabels.length === 0
            ? this.data.getQuestions()
            : this.fieldLabels;
        const formData = new FormData();
        formData.append('document', file);
        const promptName = this.data.uploadSettings.promptName;
        const ocrType = this.data.uploadSettings.ocrType;

        let viewFileData;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = x => {
          viewFileData = reader.result;
          this.displayPdfData.push({
            file: file.name,
            data: viewFileData.replace('data:application/pdf;base64,', ''),
          });
        };

        this.showNetworkLoading = true;

        this.filesLoading.push({
          file: file.name,
          subscription: this.admnSrvc
            .uploadFileToProcess(
              formData,
              promptName,
              ocrType,
              JSON.stringify(context)
            )
            .subscribe({
              next: (res: string | null) => {
                if (res) {
                  try {
                    const parsedItem: ParsedItem = JSON.parse(res);
                    this.handleResponse('success', file.name, parsedItem);
                  } catch (error) {
                    this.loading = false;
                    console.error(error);
                    this.errorFiles.push(file.name);
                    if (this.currentFiles.length === 1) {
                      this.currentStepStack.pop();

                      this.currentStepStack.push({ stepType: 'error' });
                      this.currentStep = { stepType: 'error' };
                    }
                  }
                }
              },
              error: () => {
                this.loading = false;
                this.errorFiles.push(file.name);
                if (
                  this.currentFiles.length === 1 ||
                  this.currentFiles.length === this.errorFiles.length
                ) {
                  this.currentStepStack.pop();

                  this.currentStepStack.push({ stepType: 'error' });
                  this.currentStep = { stepType: 'error' };
                }
              },
            }),
        });
      });
    }
  }

  checkSubscriptions(): boolean {
    // Returns true if all subscriptions are loading, or if any not loading files are in errorFiles.
    return (
      this.filesLoading.length &&
      this.filesLoading.every(
        fileItem =>
          !fileItem.subscription.closed ||
          this.errorFiles.includes(fileItem.file)
      )
    );
  }
  checkSubscriptionsComplete(): boolean {
    // returns true if all subscriptions are complete. returns false if any are not done loading.
    return (
      this.filesLoading.length &&
      this.filesLoading.every(fileItem => fileItem.subscription.closed)
    );
  }

  handleResponse(
    response: string,
    currentFileName: string,
    parsedItem?: ParsedItem
  ) {
    this.loadingHeadline = 'Complete!';
    this.showNetworkLoading = false;
    setTimeout(() => {
      if (
        this.currentStepStack.find(stepItem => stepItem.stepType === 'loading')
      ) {
        this.currentStepStack.pop();
        this.currentStep = { stepType: 'upload' };
      }

      this.mainLoading = false;
      this.showNetworkLoading = true;
      const parseAlerts = parsedItem?.['alerts'] || [];
      delete parsedItem?.['alerts'];
      const dataKey = Object.keys(parsedItem).find(key => key !== 'DataType');
      switch (dataKey) {
        case 'results': {
          const questionnaireItems = parsedItem?.['results']?.filter(
            result => result.section === 'Questionnaire'
          );
          this.itemType = 'results';

          const piiItems = parsedItem?.['results']?.filter(
            result => result.section === 'PII'
          );

          const dataType = parsedItem?.['results']?.filter(
            result => result.section === 'DataType'
          )?.[0]?.value;
          if (dataType) this.fileTypeMap.set(currentFileName, dataType);

          if (piiItems?.[0]?.questions.length) {
            piiItems[0].questions.forEach(item => {
              switch (item?.controlType?.toLowerCase()) {
                case 'ssn':
                  item.value = this.formatSSN(item.value) as string;
                  break;
                case 'ein':
                  item.value = this.formatEIN(item.value) as string;
                  break;
                case 'zip':
                  item.value = this.formatZIP(item.value) as string;
                  break;
                case 'phone':
                  item.value = this.formatPhone(item.value) as string;
                  break;
                case 'email':
                  Object.assign(item, {
                    formCtrl: new FormControl('', [
                      Validators.pattern(
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      ),
                    ]),
                  });
                  break;
                case 'monthdate':
                  if (item?.value && typeof item.value === 'string') {
                    Object.assign(item, {
                      formCtrl: new FormControl<DateTime>(
                        DateTime.fromJSDate(
                          new Date(
                            +item.value.split('/')[2],
                            +item.value.split('/')[1] - 1
                          )
                        )
                      ),
                    });
                  }
                  item?.formCtrl?.valueChanges.subscribe((value: DateTime) => {
                    if (item.future) {
                      if (
                        value.toJSDate() <
                        DateTime.fromJSDate(new Date()).startOf('month')
                      ) {
                        item?.formCtrl?.setErrors({ pastError: true });
                      }
                    } else {
                      if (
                        value.toJSDate() >
                        DateTime.fromJSDate(new Date()).startOf('month')
                      ) {
                        item?.formCtrl?.setErrors({ futureError: true });
                      }
                    }
                  });
                  break;
                case 'date':
                  Object.assign(item, {
                    formCtrl: new FormControl<DateTime>(
                      DateTime.fromJSDate(new Date(item.value as string))
                    ),
                  });
                  item?.formCtrl?.valueChanges.subscribe((value: DateTime) => {
                    if (item.future) {
                      if (
                        value.toJSDate() <
                        DateTime.fromJSDate(new Date()).startOf('day')
                      ) {
                        item?.formCtrl?.setErrors({ pastError: true });
                      }
                    } else {
                      if (
                        value.toJSDate() >
                        DateTime.fromJSDate(new Date()).startOf('day')
                      ) {
                        item?.formCtrl?.setErrors({ futureError: true });
                      }
                    }
                  });
                  break;
                default:
                  break;
              }
            });
          }
          Object.assign(this.selectedItems, {
            [`${currentFileName}-PII`]: piiItems?.[0],
          });

          if (questionnaireItems && questionnaireItems.length > 1) {
            this.currentStepStack = [
              ...this.currentStepStack,
              {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              },
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              };
            }
          } else if (questionnaireItems && questionnaireItems.length === 1) {
            Object.assign(this.selectedItems, {
              [`${currentFileName}`]: questionnaireItems[0],
            });
            this.currentStepStack = [
              ...this.currentStepStack,
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            this.userSelectedItem = this.selectedItems[currentFileName];
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'parse',
              };
            }
            this.fillParsedFields(currentFileName);
          }
          break;
        }
        case 'accounts': {
          // IW
          this.itemType = 'accounts';
          const questionnaireItems = parsedItem?.['accounts'];
          const dataType = parsedItem?.['DataType'];
          if (dataType) this.fileTypeMap.set(currentFileName, dataType);
          this.fundDetailsVarset = 'CurrentPosition';
          if (questionnaireItems && questionnaireItems.length > 1) {
            this.currentStepStack = [
              ...this.currentStepStack,
              {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              },
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              };
            }
          } else if (questionnaireItems && questionnaireItems.length === 1) {
            Object.assign(this.selectedItems, {
              [currentFileName]: parsedItem?.accounts?.[0],
            });
            this.currentStepStack = [
              ...this.currentStepStack,
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'parse',
              };
            }
            this.fillParsedFields(currentFileName);
          }
          break;
        }
        case 'rollover': {
          // PP
          this.itemType = 'rollover';
          const questionnaireItems = parsedItem?.['rollover'];
          const dataType = parsedItem?.['DataType'];
          if (dataType) this.fileTypeMap.set(currentFileName, dataType);
          parsedItem['rollover'].forEach(item => {
            Object.keys(item).forEach(itemKey => {
              if (!Array.isArray(item[itemKey])) {
                item[`${this.data.varset}_${itemKey}`] = item[itemKey];
                delete item[itemKey];
              }
            });
          });
          if (questionnaireItems && questionnaireItems.length > 1) {
            this.currentStepStack = [
              ...this.currentStepStack,
              {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              },
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              };
            }
          } else if (questionnaireItems && questionnaireItems.length === 1) {
            Object.assign(this.selectedItems, {
              [currentFileName]: parsedItem?.rollover?.[0],
            });
            this.currentStepStack = [
              ...this.currentStepStack,
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'parse',
              };
            }
            this.fillParsedFields(currentFileName);
          }
          break;
        }
        case 'insurance': {
          // LI
          this.itemType = 'insurance';
          const questionnaireItems = parsedItem?.['insurance'];
          const dataType = parsedItem?.['DataType'];
          if (dataType) this.fileTypeMap.set(currentFileName, dataType);
          parsedItem['insurance'].forEach(item => {
            Object.keys(item).forEach(itemKey => {
              if (!Array.isArray(item[itemKey])) {
                item[`${this.data.varset}_${itemKey}`] = item[itemKey];
                delete item[itemKey];
              }
            });
          });
          if (questionnaireItems && questionnaireItems.length > 1) {
            this.currentStepStack = [
              ...this.currentStepStack,
              {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              },
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              };
            }
          } else if (questionnaireItems && questionnaireItems.length === 1) {
            Object.assign(this.selectedItems, {
              [currentFileName]: parsedItem?.insurance?.[0],
            });
            this.currentStepStack = [
              ...this.currentStepStack,
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'parse',
              };
            }
            this.fillParsedFields(currentFileName);
          }
          break;
        }
        case 'exchange': {
          // AW
          this.itemType = 'exchange';
          const questionnaireItems = parsedItem?.['exchange'];
          const dataType = parsedItem?.['DataType'];
          if (dataType) this.fileTypeMap.set(currentFileName, dataType);
          if (questionnaireItems && questionnaireItems.length > 1) {
            this.currentStepStack = [
              ...this.currentStepStack,
              {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              },
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];

            Object.assign(this.itemsToSelect, {
              [currentFileName]: questionnaireItems,
            });
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'select',
              };
            }
          } else if (questionnaireItems && questionnaireItems.length === 1) {
            Object.assign(this.selectedItems, {
              [currentFileName]: parsedItem?.exchange?.[0],
            });
            this.currentStepStack = [
              ...this.currentStepStack,
              { file: currentFileName, alerts: parseAlerts, stepType: 'parse' },
            ];
            if (this.currentStep.stepType === 'upload') {
              this.currentStep = {
                file: currentFileName,
                alerts: parseAlerts,
                stepType: 'parse',
              };
            }
            this.fillParsedFields(currentFileName);
          }
          break;
        }
        default:
          break;
      }
    }, 500);
  }

  alertsContinue() {
    delete this.currentStep.alerts;
    delete this.currentStepStack[this.currentStepStack.length - 1].alerts;
  }

  fillParsedFields(fileNameSetup = this.currentStep.file): void {
    this.loadingFields = true;
    this.data.saveToModel(this.selectedItem, this.data.varset); // may need to modify this to not overwrite each other

    if (this.itemType === 'results') {
      // CI
      const modifyArray = [];
      const groupedQuestions = new Map<
        string,
        {
          varName: string;
          value: Record<string, unknown>[];
          checked: boolean;
          grouped: boolean;
        }
      >();
      this.selectedItems[fileNameSetup].questions.forEach(question => {
        // Parallel scalar arrays share their prefix and row index; object arrays keep the existing Fund Details path.
        if (
          question.varName?.includes('.') &&
          Array.isArray(question.value) &&
          question.value.every(
            value => value === null || typeof value !== 'object'
          )
        ) {
          const [groupName, fieldName] = question.varName.split('.');
          let group = groupedQuestions.get(groupName);
          if (!group) {
            group = {
              varName: groupName,
              value: [],
              checked: true,
              grouped: true,
            };
            groupedQuestions.set(groupName, group);
            modifyArray.push(group);
          }
          question.value.forEach((value, index) => {
            group.value[index] ??= { checked: true };
            group.value[index][fieldName] = value;
          });
          return;
        }
        const fieldObject = {};
        Object.keys(question).forEach(currentKey => {
          if (Array.isArray(question['value'])) {
            question['value'].forEach(subItem => {
              subItem['checked'] = true;
            });
          }
          fieldObject[`${currentKey}`] = question[currentKey];
        });

        fieldObject['checked'] = true;

        modifyArray.push(fieldObject);
      });
      this.selectedItems[fileNameSetup].questions = modifyArray;

      const modifyArrayPII = [];
      if (this.selectedItems[`${fileNameSetup}-PII`])
        this.selectedItems[`${fileNameSetup}-PII`].questions.forEach(
          question => {
            const fieldObject = {};
            Object.keys(question).forEach(currentKey => {
              fieldObject[`${currentKey}`] = question[currentKey];
            });

            fieldObject['checked'] = true;

            modifyArrayPII.push(fieldObject);
          }
        );
      if (this.selectedItems[`${fileNameSetup}-PII`])
        this.selectedItems[`${fileNameSetup}-PII`].questions = modifyArrayPII;

      const labelList = [];
      const notFoundLabelList = [];

      // Reusable function to process questions
      const processQuestions = questions => {
        questions.forEach(q => {
          const fieldNames = q.grouped
            ? Object.keys(q.value[0] || {})
                .filter(field => field !== 'checked')
                .map(field => `${q.varName}.${field}`)
            : [q.field || q.varName];
          fieldNames.forEach(fieldName => {
            const labelItem = this.fieldLabels.find(
              fieldLabel =>
                fieldLabel.key === fieldName ||
                fieldLabel.key === fieldName.replace('.', '_') ||
                fieldLabel.key === `${this.data.varset}_${fieldName}` ||
                fieldLabel.key === `${this.fundDetailsVarset}_${fieldName}`
            );
            if (labelItem) {
              labelList.push(labelItem);
            } else {
              notFoundLabelList.push(fieldName);
            }
          });
        });
      };

      processQuestions(this.selectedItems[`${fileNameSetup}`].questions);

      // Append only labels whose key isn't already in fieldLabels.
      const addMissingLabels = () => {
        const missingLabels = labelList.filter(
          labelItem =>
            !this.fieldLabels.some(
              fieldLabel => fieldLabel.key === labelItem.key
            )
        );
        this.fieldLabels = [...this.fieldLabels, ...missingLabels];
      };

      if (notFoundLabelList.length) {
        this.admnSrvc
          .getQuestionsFromList(notFoundLabelList, this.data.profile, 'rb')
          .subscribe({
            next: res => {
              Object.keys(res).forEach(resKey => {
                res[resKey].questions.forEach(questionItem => {
                  if (
                    !labelList.find(labelItem => {
                      return (
                        labelItem.key ===
                        questionItem.varName.split('.').join('_')
                      );
                    })
                  ) {
                    //label
                    let labelToUse = questionItem.label;
                    if (labelToUse) {
                      const labelMatch = questionItem.label.match(/{{(.*?)}}/);
                      if (labelMatch) {
                        const varNameToFind = labelMatch[1];

                        const refVarItem = res[resKey].refVar.find(
                          refItem => refItem.varName === varNameToFind
                        );

                        if (refVarItem && refVarItem.display) {
                          labelToUse = refVarItem.display;
                        }
                      }
                    }

                    //placeholder
                    let placeholderToUse = questionItem.placeholder;
                    if (placeholderToUse) {
                      const placeholderMatch =
                        questionItem.placeholder.match(/{{(.*?)}}/);
                      if (placeholderMatch) {
                        const varNameToFind = placeholderMatch[1];

                        const refVarItem = res[resKey].refVar.find(
                          refItem => refItem.varName === varNameToFind
                        );

                        if (refVarItem && refVarItem.display) {
                          placeholderToUse = refVarItem.display;
                        }
                      }
                    }

                    //prompt
                    let promptToUse = questionItem.prompt;
                    if (promptToUse) {
                      const promptMatch =
                        questionItem.prompt.match(/{{(.*?)}}/);
                      if (promptMatch) {
                        const varNameToFind = promptMatch[1];

                        const refVarItem = res[resKey].refVar.find(
                          refItem => refItem.varName === varNameToFind
                        );

                        if (refVarItem && refVarItem.display) {
                          promptToUse = refVarItem.display;
                        }
                      }
                    }

                    let dynamicOptions = [];

                    if (questionItem.dynamicValidation) {
                      const generateOptions = data => {
                        const { refVar } = data;
                        const { val, display } = questionItem.dynamicValidation;

                        const valRef = refVar.find(ref => ref.varName === val);
                        const displayRef = refVar.find(
                          ref => ref.varName === display
                        );

                        if (valRef && displayRef && valRef.rawValue) {
                          return valRef.rawValue.map((value, index) => ({
                            value: value,
                            label: displayRef.display[index] || value,
                          }));
                        }
                        return [];
                      };
                      dynamicOptions = generateOptions(res[resKey]);
                    }
                    const foundProps = {
                      label: labelToUse || questionItem.label,
                      placeholder: placeholderToUse || questionItem.placeholder,
                      prompt: promptToUse || questionItem.prompt,
                      group: questionItem.group,
                      options:
                        dynamicOptions.length > 0
                          ? dynamicOptions
                          : questionItem.options.length > 0
                            ? questionItem.options
                            : null,
                    };
                    const itemToPush = {
                      key: questionItem.varName.split('.').join('_'),
                      label: labelToUse || questionItem.label,
                      hidden: questionItem.hidden,
                      type: this.checkControlType(questionItem.controlType),
                      props: foundProps,
                    };
                    labelList.push(itemToPush);
                  }
                });
              });
              addMissingLabels();
              this.loadingFields = false;
            },
            error: () => {
              addMissingLabels();
              this.loadingFields = false;
              console.error(
                'There was an unexpected error retrieving field data.'
              );
            },
          });
      } else {
        this.loadingFields = false;
      }
    } else if (this.itemType === 'accounts') {
      // IW
      const modifyArray = [];
      this.selectedItems[fileNameSetup].CurrentPosition.forEach(
        currentPosition => {
          const fieldObject = {};
          Object.keys(currentPosition).forEach(currentKey => {
            Object.assign(fieldObject, {
              [currentKey]: currentPosition[currentKey],
            });
            fieldObject['checked'] = true;
          });
          modifyArray.push(fieldObject);

          Object.assign(this.selectedItems[fileNameSetup], {
            questions: [],
          });

          this.selectedItems[fileNameSetup].questions = modifyArray;
        }
      );
      this.loadingFields = false;
    } else if (this.itemType === 'rollover' || this.itemType === 'insurance') {
      // PP

      const modifyArray = [];
      Object.keys(this.selectedItems[fileNameSetup]).forEach(currentKey => {
        const fieldObject = {};

        if (Array.isArray(this.selectedItems[fileNameSetup][currentKey])) {
          this.selectedItems[fileNameSetup][currentKey].forEach(subItem => {
            subItem['checked'] = true;
          });
        }
        Object.assign(fieldObject, {
          field: currentKey,
          value: this.selectedItems[fileNameSetup][currentKey],
        });
        fieldObject['checked'] = true;
        modifyArray.push(fieldObject);
      });

      Object.assign(this.selectedItems[fileNameSetup], {
        questions: modifyArray,
      });

      this.selectedItems[fileNameSetup].questions = modifyArray;
      this.loadingFields = false;
    } else if (this.itemType === 'exchange') {
      // AW
      const modifyArray = [];
      Object.keys(this.selectedItems[fileNameSetup]).forEach(currentKey => {
        const fieldObject = {};
        Object.assign(fieldObject, {
          field: currentKey,
          value: this.selectedItems[fileNameSetup][currentKey],
        });
        fieldObject['checked'] = true;
        modifyArray.push(fieldObject);
      });

      Object.assign(this.selectedItems[fileNameSetup], {
        questions: [],
      });

      this.selectedItems[fileNameSetup].questions = modifyArray;
      this.loadingFields = false;
    }
  }

  checkboxChange(ev, position) {
    position.checked = !position.checked;
  }

  updateValues(ev, position, item): void {
    if (
      (Object.prototype.hasOwnProperty.call(position, 'field') ||
        Object.prototype.hasOwnProperty.call(position, 'varName')) &&
      Object.prototype.hasOwnProperty.call(position, 'value')
    ) {
      position['value'] = item.value;
    } else {
      position[item.key] = item.value;
    }
  }

  safeBlur(
    formatter: (item: any, event: Event) => void | string,
    item: any,
    event: Event
  ): void {
    try {
      formatter.call(this, item, event);
    } catch (err) {
      console.error('blur formatter failed', err);
    }
    this.updateValues(event, item, item);
  }

  // Only keyless items (no field/varName) are compared by shared sub-keys; keyed items are deduped by field/varName.
  checkSubQuestions(selectItem, position) {
    if (
      selectItem.field ||
      selectItem.varName ||
      position.field ||
      position.varName
    ) {
      return false;
    }
    return Object.keys(position).some(
      positionKey =>
        positionKey !== 'checked' &&
        Object.keys(selectItem).includes(positionKey)
    );
  }

  submitSelection(): void {
    let returnQuestions = [];
    let reformattedPII = [];

    Object.keys(this.selectedItems).forEach(key => {
      if (key.slice(-4) !== '-PII') {
        returnQuestions = [
          ...returnQuestions,
          ...this.selectedItems[key].questions.filter(
            selectItem =>
              selectItem.checked &&
              !returnQuestions.find(
                position =>
                  (selectItem.field !== undefined &&
                    position.field === selectItem.field) ||
                  (selectItem.varName !== undefined &&
                    position.varName === selectItem.varName) ||
                  this.checkSubQuestions(selectItem, position)
              )
          ),
        ];
      } else {
        // need to compile pii here.
        if (this.selectedItems[key]?.questions) {
          reformattedPII = [
            ...reformattedPII,
            ...this.selectedItems[key].questions.map(question => ({
              [question.varName]: question.value,
            })),
          ];
        }
      }
    });
    if (reformattedPII.length) {
      this.savePII(reformattedPII, returnQuestions);
    } else {
      this.saveSelectedFiles(false, undefined, returnQuestions);
    }
  }

  savePII(reformattedPII, returnQuestions) {
    this.piiSave = true;
    this.piiErrorSave = false;
    const piiJSONFile = new File(
      [new Blob([JSON.stringify(reformattedPII)])],
      'pii.json',
      {
        type: 'application/json',
      }
    );
    const formData = new FormData();
    const fileName = piiJSONFile['name'];
    const fileType = piiJSONFile['type'];
    formData.append('File', piiJSONFile);

    this.admnSrvc.extStorage(formData, this.data.profile).subscribe({
      next: () => {
        this.piiSave = false;
        this.saveSelectedFiles(false, undefined, returnQuestions);
      },
      error: () => {
        this.piiSave = false;
        this.piiErrorSave = true;
      },
    });
  }

  saveSelectedFiles(
    waitForResponse = false,
    filesToTry: File[] = this.currentFiles,
    returnQuestions?
  ) {
    if (waitForResponse) {
      this.uploadedSaveFiles = [];
      this.errorSaveFiles = [];
      this.normalFileSave = true;
      this.normalFileErrorSave = false;
      this.errorSaveMessage = '';

      const uploadObservables = filesToTry.map((file: File) => {
        const formData = new FormData();
        formData.append('File', file);

        return this.admnSrvc.extStorage(formData, this.data.profile).pipe(
          map(res => {
            this.uploadedSaveFiles.push(file);
            return res;
          }),
          catchError(x => {
            if (x?.error?.errorMessage) {
              this.errorSaveMessage = x.error.errorMessage;
            }
            this.errorSaveFiles.push(file);
            return of(null);
          })
        );
      });

      forkJoin(uploadObservables).subscribe({
        next: () => {},
        error: () => {},
        complete: () => {
          this.normalFileSave = false;
          this.normalFileErrorSave = this.errorSaveFiles.length > 0;
          if (!this.normalFileErrorSave) {
            this.snacky.open(`File(s) saved!`, 'Close', {
              duration: 5000,
            });
            this.forceCloseModal({ fileSaved: true });
          }
        },
      });
    } else {
      filesToTry.forEach((file: File) => {
        const fileDataType = this.fileTypeMap.get(file.name);
        const formData = new FormData();
        formData.append('File', file);

        if (fileDataType) {
          this.admnSrvc
            .extStorage(formData, this.data.profile, fileDataType)
            .subscribe();
        }
      });
      this.sendDataOutOfModal(returnQuestions);
    }
  }

  sendDataOutOfModal(returnQuestions) {
    returnQuestions = returnQuestions.filter(position => {
      if (this.itemType === 'results' && position.grouped) {
        return position.value.some(row => row.checked);
      }
      if (Array.isArray(position['value'])) {
        position['value'] = position['value']
          .filter(subItem => subItem.checked)
          .map(subItem => {
            Object.keys(subItem).forEach(subItemKey => {
              if (
                subItemKey !== 'checked' &&
                !this.includeItem(subItemKey, position['value'])
              ) {
                delete subItem[subItemKey];
              }
            });
            return subItem;
          });
        return position['value'].length > 0; // Keep the position if it has valid sub-items
      } else {
        if (Object.prototype.hasOwnProperty.call(position, 'field')) {
          const shouldKeep =
            this.includeItem(position['field'], returnQuestions) ||
            (position['field']?.includes('UserHas404a5') &&
              position['value'] === 'Y'); // Retain 404a5 question
          if (!this.templateMode) {
            delete position.checked;
          }
          return shouldKeep; // Keep the position if it meets the condition
        }
        if (!this.templateMode) {
          delete position.checked;
        }
        return true;
      }
    });

    // Handle itemType-specific logic
    returnQuestions.forEach(position => {
      if (this.itemType === 'accounts') {
        Object.keys(position).forEach(key => {
          if (key.includes('_')) {
            position[key.split('_')[1]] = position[key];
            delete position[key];
          }
        });
      }
    });

    // below is logic for each app
    if (this.itemType === 'results') {
      this.questionnaireData = {};
      // Restore the original parallel varName/value arrays after row edits and selection.
      returnQuestions = returnQuestions.flatMap(question => {
        if (!question.grouped) return [question];
        const rows = question.value.filter(row => row.checked);
        const fields = [
          ...new Set<string>(
            rows.flatMap(row =>
              Object.keys(row).filter(
                field =>
                  field !== 'checked' &&
                  this.displayItemField(`${question.varName}.${field}`)
              )
            )
          ),
        ];
        return fields.map(field => ({
          varName: `${question.varName}.${field}`,
          value: rows.map(row => row[field]),
        }));
      });
      returnQuestions.forEach(question => {
        const fieldKey = question.field || question.varName;
        const fieldGroup = this.getItemGroup(fieldKey);
        Object.assign(this.questionnaireData, {
          [fieldKey]: question.value,
        });
        if (fieldGroup) {
          Object.assign(this.questionnaireData, {
            [`${fieldKey}_GROUP`]: fieldGroup,
          });
        }
      });
      this.docReadSvc.docData({
        data: this.questionnaireData,
      });
      this.forceCloseModal();
    } else if (this.itemType === 'accounts') {
      this.unifiedFlowService.setLoading(true);
      const symbolList = [];
      returnQuestions.forEach(position => {
        if (position.FundID) {
          symbolList.push(position.FundID);
        }
      });
      this.iws.fundInfo(symbolList).subscribe(res => {
        res.results.forEach(fund => {
          const currentPosition = returnQuestions.find(
            position => position.FundID === fund.Symbol
          );
          if (currentPosition) {
            Object.assign(currentPosition, {
              FundName: fund.FundName,
              FundType: fund.FundType,
              ExpenseRatio: fund.ExpenseRatio,
              ShareClass: fund.ShareClass,
            });
          }
        });
        this.dialogRef.close(returnQuestions);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef = null;
        });
      });
    } else if (this.itemType === 'exchange') {
      this.exchangeData = {};
      returnQuestions.forEach(question => {
        Object.assign(this.exchangeData, {
          [question.field || question.varName]: question.value,
        });
      });
      if (!this.templateMode) {
        this.docReadSvc.docData({
          currentApp: 'aw',
          data: this.exchangeData,
          index: +this.data.index,
          group: this.data.group,
          varset: this.data.varset,
        });
        this.forceCloseModal();
      } else {
        this.templateDataOut.emit({
          docData: {
            currentApp: 'aw',
            data: this.exchangeData,
            index: +this.data.index,
            group: this.data.group,
            varset: this.data.varset,
          },
        });
      }
    } else if (this.itemType === 'rollover' || this.itemType === 'insurance') {
      this.selectedPlanData = {};

      returnQuestions.forEach(question => {
        Object.assign(this.selectedPlanData, {
          [question.field || question.varName]: question.value,
        });
      });
      this.selectedPlanData['server'] = this.server;
      this.selectedPlanData['groupIndex'] = this.groupIndex;
      this.selectedPlanData['buttonType'] =
        this.fundType ?? this.data.buttonType;
      this.selectedPlanData['varset'] = this.data.varset;
      this.selectedPlanData['group'] = this.data.group;
      let returnFundDetails;
      Object.keys(this.selectedPlanData).forEach(planKey => {
        if (planKey.includes('_')) {
          if (this.itemType === 'rollover' && planKey.includes('_PlanName')) {
            this.selectedPlanData['PLAN_NAME'] = this.selectedPlanData[planKey];
          } else {
            this.selectedPlanData[planKey.split('_')[1]] =
              this.selectedPlanData[planKey];
          }
          delete this.selectedPlanData[planKey];
        }
        if (Array.isArray(this.selectedPlanData[planKey])) {
          returnFundDetails = this.selectedPlanData[planKey].filter(detail => {
            let returnThis = false;
            if (detail.checked) {
              returnThis = true;
            }
            if (!this.templateMode) {
              delete detail.checked;
            }
            return returnThis;
          });
        }
      });
      this.selectedPlanData['currentApp'] =
        this.itemType === 'rollover' ? 'pp' : 'li';
      if (!this.templateMode) {
        this.docReadSvc.docData(this.selectedPlanData);
      } else {
        this.templateDataOut.emit({ docData: this.selectedPlanData });
      }
      if (returnFundDetails) {
        this.unifiedFlowService.setLoading(true);
        const symbolList = [];
        returnFundDetails.forEach(position => {
          if (position.FundID) {
            symbolList.push(position.FundID);
          }
        });
        this.iws.fundInfo(symbolList).subscribe(res => {
          res.results.forEach(fund => {
            const currentPosition = returnFundDetails.find(
              position => position.FundID === fund.Symbol
            );
            if (currentPosition) {
              Object.assign(currentPosition, {
                FundName: fund.FundName,
                FundType: fund.FundType,
                ExpenseRatio: fund.ExpenseRatio,
                ShareClass: fund.ShareClass,
              });
            }
          });

          const returnData = this.parsedValues(returnFundDetails);
          if (!this.templateMode) {
            this.dialogRef.close(returnData);
            this.dialogRef.afterClosed().subscribe(() => {
              this.dialogRef = null;
              this.unifiedFlowService.setLoading(false);
            });
          } else {
            this.templateDataOut.emit({
              docDataDetail: returnData,
              fundDetailIDs: this.data.docReadFundDetailIDs,
            });
          }
        });
      } else {
        if (!this.templateMode) {
          this.dialogRef.close();
          this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
            this.unifiedFlowService.setLoading(false);
          });
        }
      }
    } else {
      if (!this.templateMode) {
        this.dialogRef.close();
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef = null;
          this.unifiedFlowService.setLoading(false);
        });
      }
    }
  }

  checknext(): boolean {
    if (
      this.currentStep.stepType === 'upload' &&
      this.currentFiles.length === 0
    ) {
      return true;
    }
    if (
      this.currentStep.stepType === 'loading' ||
      this.currentStep.stepType === 'error'
    ) {
      return true;
    }
    if (this.currentStep.stepType === 'select' && !this.userSelectedItem) {
      return true;
    }
    if (
      this.currentStep.stepType === 'reconcile' &&
      this.duplicates.some(dup =>
        dup.dupValues.every(dupVal => !dupVal.checked)
      )
    ) {
      return true;
    }
    if (this.normalFileErrorSave) {
      return true;
    }
    return false;
  }

  forceCloseModal(dataOut?): void {
    this.dialogRef.close(dataOut);
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  checkStep(step: string): string {
    switch (step) {
      case 'current':
        return this.currentStepStack[this.currentStepStack.length - 1]
          ?.stepType;
      case 'previous':
        return this.currentStepStack[this.currentStepStack.length - 2]
          ?.stepType;

      default:
        break;
    }
  }

  parsedValues(dataDetail) {
    dataDetail.forEach(data => {
      Object.keys(data).forEach(dataKey => {
        if (dataKey.includes('_')) {
          data[dataKey.split('_')[1]] = data[dataKey];
          delete data[dataKey];
        }
      });
    });

    return dataDetail;
  }

  findDuplicateQuestions() {
    this.duplicates = [];
    const fieldMap = {};

    // Traverse each top-level key in selectedItems
    for (const [key, data] of Object.entries(this.selectedItems)) {
      if (data?.['questions']) {
        const questions = data['questions'];

        // Process each question
        for (const question of questions) {
          let { field, value, label } = question;
          if (!field) field = question.varName;

          // Initialize field in fieldMap if not already present
          if (!fieldMap[field]) {
            fieldMap[field] = { values: {}, label: label || null };
          }

          // Initialize value in fieldMap[field].values if not already present
          if (!fieldMap[field].values[value]) {
            fieldMap[field].values[value] = [];
          }

          // Add the current top-level key to the list of keys for this value
          fieldMap[field].values[value].push(key);

          // Update the label if it exists (ensures the label is captured)
          if (label) {
            fieldMap[field].label = label;
          }
        }
      }
    }

    // Construct the output array, excluding fields with only one unique value
    const result = Object.entries(fieldMap)
      .filter(([_, data]) => Object.keys(data['values']).length > 1) // Exclude fields with only one unique value
      .map(([field, data]) => {
        const dupValues = Object.entries(data['values']).map(
          ([value, keys]) => ({
            checked: false,
            value,
            keys,
          })
        );
        return { field, dupValues, label: data['label'] };
      });

    this.duplicates = result;

    if (this.duplicates.length) {
      this.currentStepStack.push({ stepType: 'reconcile' });
      this.currentStep = { stepType: 'reconcile' };
    } else {
      this.submitSelection();
    }
  }

  checkboxReconcile(ev, dupVal, iIndex: number, jIndex: number) {
    dupVal.checked = !dupVal.checked;
    this.duplicates[iIndex].dupValues.forEach((val, index) => {
      if (index !== jIndex) {
        val.checked = false;
      }
    });
  }

  displayFileKeys(keys): string[] {
    const strArray = [];
    this.currentFiles.forEach(file => {
      keys.forEach(key => {
        if (key.includes(file.name)) {
          strArray.push(file.name);
        }
      });
    });
    return strArray;
  }

  updateSelectedItemsFromDuplicates() {
    this.duplicates.forEach(duplicate => {
      // Find the item in duplicates where checked === true
      const checkedItem = duplicate.dupValues.find(
        (item: any) => item.checked === true
      );

      if (checkedItem) {
        const checkedValue = checkedItem.value;

        // Traverse through selectedItems
        Object.keys(this.selectedItems).forEach((key: any) => {
          if (this.selectedItems[key]?.questions) {
            this.selectedItems[key].questions.forEach((question: any) => {
              // Find the corresponding field and update its value
              if (
                question.field === duplicate.field ||
                question.varName === duplicate.field
              ) {
                question.value = checkedValue;
              }
            });
          }
        });
      }
    });
  }

  getStepTitle(): string {
    if (this.currentStep.stepType === 'reconcile') {
      return `Review Duplicate Data`;
    } else {
      const currentFile = this.currentStep.file; // Get the current file from the current step
      const currentIndex = this.getCurrentStepIndex(); // Get the current step index

      // Extract unique files from the currentStepStack up to the current step
      const reviewedFiles = this.currentStepStack
        .slice(0, currentIndex + 1) // Only consider steps up to the current step
        .filter(step => step.file) // Filter steps that have a 'file' attribute
        .map(step => step.file) // Map to the 'file' attribute
        .filter((file, index, self) => self.indexOf(file) === index); // Remove duplicates

      // Find the index of the current file in the reviewedFiles array
      const currentFileIndex = reviewedFiles.indexOf(currentFile) + 1; // Add 1 to make it 1-based

      // Get the total number of unique files in the currentFiles array
      const totalFiles = this.currentFiles.length;

      // Return the progress as "Reviewing file X of Y"
      return `Review File ${currentFileIndex} of ${totalFiles}`;
    }
  }

  getSelectStepCount(): number {
    const currentStepIndex = this.getCurrentStepIndex();
    const selectSteps = this.currentStepStack
      .slice(0, currentStepIndex + 1) // Traverse up to the current step
      .filter(stepItem => stepItem.stepType === 'select'); // Filter by stepType 'select'
    return selectSteps.length; // Return the length of the filtered list
  }

  getPdfData(): string {
    return this.displayPdfData.find(
      dataItem => dataItem.file === this.currentStep.file
    )?.data;
  }

  checkIfFilesParsed() {
    return this.currentStepStack.some(step => step.stepType === 'parse');
  }

  formatSSN(input, event?): void | string {
    let value;
    if (event) {
      value = event.target.value;
      value = value.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    } else {
      value = input.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    }

    // Format the value as XXX-XX-XXXX
    if (value.length > 5) {
      value = `${value.substring(0, 3)}-${value.substring(
        3,
        5
      )}-${value.substring(5, 9)}`;
    } else if (value.length > 3) {
      value = `${value.substring(0, 3)}-${value.substring(3, 5)}`;
    }

    if (event) {
      input.value = value;
    }

    return value;
  }

  formatEIN(input, event?): void | string {
    let value;
    if (event) {
      value = event.target.value;
      value = value.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    } else {
      value = input.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    }

    // Format the value as XX-XXXXXXX
    if (value.length > 2) {
      value = `${value.substring(0, 2)}-${value.substring(2, 9)}`;
    }

    if (event) {
      input.value = value;
    }

    return value;
  }

  formatZIP(input, event?): void | string {
    let value;
    if (event) {
      value = event.target.value;
      value = value.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    } else {
      value = input.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    }

    // Format the value as XXXXX-XXXX
    if (value.length > 5) {
      value = `${value.substring(0, 5)}-${value.substring(5, 9)}`;
    }

    if (event) {
      input.value = value;
    }

    return value;
  }

  formatPhone(input, event?): void | string {
    let value;
    if (event) {
      value = event.target.value;
      value = value.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    } else {
      value = input.replaceAll(/\D/g, ''); // Remove all non-numeric characters
    }

    // Format the value as 123-456-7890 and shift formatting for extra characters
    if (value.length > 3) {
      value = `${value.substring(0, value.length - 7)}-${value.substring(
        value.length - 7,
        value.length - 4
      )}-${value.substring(value.length - 4)}`;
    }

    if (event) {
      input.value = value;
    }

    return value;
  }

  setMonthAndYear(
    normalizedMonthAndYear,
    datepicker: MatDatepicker<any>,
    item
  ) {
    const ctrlValue = DateTime.fromObject({
      month: normalizedMonthAndYear.month,
      year: normalizedMonthAndYear.year,
    });
    item.formCtrl.setValue(ctrlValue);
    item.value = ctrlValue.toString();
    datepicker.close();
  }

  checkControlType(type: string): string {
    switch (type.toLowerCase()) {
      case 'text':
        return 'custom-input';
      case 'textexplanation':
        return 'custom-input-exp';
      case 'textbox':
        return 'custom-input';
      case 'textarea':
        return 'custom-textarea';
      case 'dropdown':
        return 'custom-drop';
      case 'dropexplanation':
        return 'custom-drop-exp';
      case 'typeahead':
        return 'custom-type-ahead';
      case 'currency':
        return 'custom-currency';
      case 'currencyexplanation':
        return 'custom-currency-exp';
      case 'rankorder':
        return 'custom-rankorder';
      case 'radiobutton':
        return 'custom-radio';
      case 'radioexplanation':
        return 'custom-radio-exp';
      case 'radiovalidate':
        return 'custom-radio-validate';
      case 'radiovalidateexplanation':
        return 'custom-radio-validate-exp';
      case 'integerexplanation':
        return 'custom-integer-exp';
      case 'numberexplanation':
        return 'custom-number-exp';
      case 'number':
        return 'custom-number';
      case 'multiselect':
        return 'custom-multi-select';
      case 'slider':
        return 'custom-radio';
      case 'checkbox':
        return 'custom-checkbox';
      case 'percentage':
        return 'custom-percentage';
      case 'percentageexplanation':
        return 'custom-percentage-exp';
      case 'message':
        return 'custom-message';
      case 'sectionheader':
        return 'custom-sectionHeader';
      case 'date':
        return 'custom-date';
      case 'datecalc':
        return 'custom-date-calc';
      case 'manuallookupdocument':
        return 'custom-manual-lookup-document';
      case 'button':
        return 'custom-button';
      case 'validatedcheck':
        return 'custom-yesno';
      case 'hash':
        return 'custom-hash';
      case 'insuredswap':
        return 'custom-insuredSwap';
      case 'repcode':
        return 'custom-repCode';
      case 'status':
        return 'custom-status';
      case 'gridExpand':
        return 'custom-gridExpand';
      case 'datagrid':
        return 'custom-dataGrid';
      case 'grid':
        return 'custom-grid';
      case 'incomechart':
        return 'custom-income-chart';
      case 'stepper':
        return 'stepper';
      case 'unified':
        return 'unified';
      case 'tabs':
        return 'tabs';
      default:
        return 'custom-input';
    }
  }

  // formatPhone(input, event?): void | string {
  //   let value;
  //   if (event) {
  //     value = event.target.value;
  //     value = value.replaceAll(/\D/g, ''); // Remove all non-numeric characters
  //   } else {
  //     value = input.replaceAll(/\D/g, ''); // Remove all non-numeric characters
  //   }
  //   let countryCode = '';

  //   // Extract country code if the length is greater than 10
  //   if (value.length > 10) {
  //     if (value.length === 11) {
  //       countryCode = `+${value.substring(0, 1)}`;
  //       value = value.substring(1);
  //     } else if (value.length === 12) {
  //       countryCode = `+${value.substring(0, 2)}`;
  //       value = value.substring(2);
  //     } else if (value.length === 13) {
  //       countryCode = `+${value.substring(0, 3)}`;
  //       value = value.substring(3);
  //     }
  //   }

  //   // Format the remaining digits as (XXX)-XXX-XXXX
  //   if (value.length <= 10) {
  //     const formattedNumber = `${countryCode} (${value.substring(
  //       0,
  //       3
  //     )})-${value.substring(3, 6)}-${value.substring(6, 10)}`;
  //     console.log(formattedNumber);
  //   } else {
  //     console.log('Invalid phone number length or format');
  //   }

  //   if (event) {
  //     input.value = value;
  //   }

  //   return value;
  // }

  // checkDate(input): boolean {
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   const value = input;
  //   console.log(value);
  //   console.log(emailRegex.test(value));
  //   return !emailRegex.test(value);
  // }
}
